import { auth } from './firebase';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  const user = auth.currentUser;
  let token = '';
  if (user) {
    token = await user.getIdToken();
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    let msg = errorData.error || errorData.message;
    if (!msg && errorData.detail) {
      if (typeof errorData.detail === 'string') {
        msg = errorData.detail;
      } else if (Array.isArray(errorData.detail)) {
        msg = errorData.detail.map((e: any) => `${e.loc?.slice(1).join('.') || 'field'}: ${e.msg}`).join('; ');
      } else {
        msg = JSON.stringify(errorData.detail);
      }
    }
    throw new Error(msg || `HTTP Error ${response.status}`);
  }

  return response.json();
};
